import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '../stores/authStore'
import { applyStatusDelta, type StatusDelta } from '../graph/statusReconcile'
import type { GraphResponse } from './useGraph'

/**
 * Subscribes to the live operational overlay (SSE) and reconciles deltas into
 * the cached graph by element_key — no polling, no refetch. EventSource can't
 * set headers, so the token rides as a query param (the backend resolver reads it).
 */
export function useStatusStream() {
  const qc = useQueryClient()
  const token = useAuthStore((s) => s.token)

  useEffect(() => {
    if (!token) return
    const es = new EventSource(`/v1/status/stream?access_token=${encodeURIComponent(token)}`)
    const onStatus = (e: MessageEvent<string>) => {
      const delta = JSON.parse(e.data) as StatusDelta
      qc.setQueriesData<GraphResponse>({ queryKey: ['graph'] }, (old) =>
        old ? applyStatusDelta(old, delta) : old,
      )
    }
    es.addEventListener('status', onStatus as EventListener)
    return () => es.close()
  }, [token, qc])
}
